import React, { useEffect, useState } from "react";
import client from "../../lib/api";
import { CAT_LABEL } from "../../lib/categories";
import { toast } from "sonner";
import { RefreshCw } from "lucide-react";

export default function FeedsAdmin() {
  const [feeds, setFeeds] = useState([]);
  const [running, setRunning] = useState(false);
  useEffect(() => { client.get("/admin/feeds").then((r) => setFeeds(r.data)); }, []);

  const runIngest = async () => {
    setRunning(true);
    try {
      const r = await client.post("/admin/ingest", null, { params: { use_ai: true } });
      toast.success(r.data.message || "Ingestion started");
    } catch { toast.error("Could not start ingestion"); }
    setTimeout(() => setRunning(false), 2500);
  };

  return (
    <div data-testid="feeds-admin">
      <div className="flex items-center justify-between mb-1">
        <h1 className="font-head font-bold text-3xl uc">Automatic News Feeds</h1>
        <button onClick={runIngest} disabled={running} data-testid="run-ingest-btn" className="bg-r24-red text-white font-bold uc text-sm px-5 py-2.5 flex items-center gap-2 disabled:opacity-50">
          <RefreshCw size={16} className={running ? "animate-spin" : ""} /> {running ? "Fetching…" : "Fetch Now"}
        </button>
      </div>
      <p className="text-gray-500 mb-6">RSS sources are fetched automatically every 10 minutes (near real-time). Trusted national/world feeds auto-publish; Lucknow, UP & crime feeds — and any item without a relevant image — go to the Review Queue.</p>

      <div className="bg-white border border-gray-200 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 border-b border-gray-200 text-left font-head uc text-xs text-gray-500">
            <tr><th className="p-3">Source</th><th className="p-3">Category</th><th className="p-3">Lang</th><th className="p-3">Policy</th></tr>
          </thead>
          <tbody>
            {feeds.map((f, i) => (
              <tr key={i} className="border-b border-gray-100">
                <td className="p-3 font-semibold">{f.source}</td>
                <td className="p-3 text-gray-600">{CAT_LABEL[f.category]?.name || f.category}</td>
                <td className="p-3 uppercase text-gray-500">{f.language}</td>
                <td className="p-3">
                  <span className={`text-[10px] uc font-bold px-2 py-0.5 ${f.auto_publish ? "bg-green-100 text-green-700" : "bg-yellow-100 text-yellow-700"}`}>
                    {f.auto_publish ? "Auto-publish" : "Review"}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
